/**
 * State
 * @type {Object}
 */
const state = {
    open: false,
    text: '',
    buttons: []
}

/**
 * Getters
 * @type {Object}
 */
const getters = {}

/**
 * Actions
 * @type {Object}
 */
const actions = {

    open({commit}, {buttons, text}) {
        commit('open', {buttons, text});
    },

    close({commit}) {
        commit('close');
    }
}

/**
 * Mutations
 * @type {Object}
 */
const mutations = {

    open(state, {buttons, text} ) {
        state.buttons = buttons;
        state.text = text;
        state.open = true;
    },

    close(state) {
        state.buttons = [];
        state.text = '';
        state.open = false;
    }
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
